import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { throttle } from 'lodash';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { FormGroup, InputGroup, Button, ControlLabel } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { fetchOrganizationUsers } from '../../modules/Setup/SetupActions';
import { listManagers, fetchManager } from '../../modules/Auth/AuthActions';
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';
import Avatar from '../avatar';

import styles from '../opportunity-selector/styles.css';

function escapeRegexCharacters (str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

class UserSelector extends Component {
  constructor () {
    super();
    this.state = {
      value: '',
      suggestions: [],
      loading: false,
      selectedValue: null,
    };
    this.onSuggestionsFetchRequested = throttle(
      this.onSuggestionsFetchRequested,
      500,
      { leading: false },
    ).bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(
      this,
    );
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onChange = this.onChange.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.forceFocus = this.forceFocus.bind(this);
  }

  componentDidMount () {
    const { userId, organization } = this.props;

    if (userId !== null) {
      const p = new Promise((resolve, reject) => {
        this.props
          .dispatch(
            this.props.isManager ? fetchManager() : fetchOrganizationUsers(organization._id, {
              q: userId,
              license: true,
            })
          )
          .then(
            (users) => {
              resolve(this.props.isManager ? [users] : users.users.items);
            },
            (e) => {
              reject(e);
            },
          );
      });

      p.then((userArr) => {
        if (userArr && userArr[0]) {
          const selectedValue = userArr[0];
          const value = `${selectedValue.first_name} ${selectedValue.last_name}`;
          this.setState({ selectedValue, value }, () => {
            // this.props.onSelect(selectedValue.user_id, value);
          });
        }
      });
    }
  }

  onChange (event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onSuggestionsFetchRequested ({ value }) {
    this.setState({ loading: true, suggestions: [], selectedValue: null });
    const p = new Promise((resolve, reject) => {
      const escapedValue = escapeRegexCharacters(value.trim());
      if (escapedValue && escapedValue.length >= 3) {
        const params = {
          ...this.props.query,
          q: escapedValue,
        };
        this.props
          .dispatch(this.props.isManager ? listManagers(params) : fetchOrganizationUsers(this.props.organization._id, params))
          .then(
            (results) => {
              const { items } = results.users

              const matched = escapedValue.match(
                /[a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}|[a-zA-Z0-9\\-]{36}/,
              );
              const isId = matched && matched !== null && matched !== undefined;
              const hasResults = items && items.length > 0;

              const mainResults = [];

              if (hasResults) {
                mainResults.push({
                  suggestions: items,
                });
              } else if (!isId) {
                mainResults.push({
                  suggestions: [
                    {
                      isEmpty: true,
                      name: 'no results found',
                    },
                  ],
                });
              }
              if (isId && !hasResults) {
                mainResults.push({
                  suggestions: [
                    {
                      name: escapedValue,
                      value: escapedValue,
                      user_id: escapedValue,
                      is_id: true,
                    },
                  ],
                });
              }
              resolve(mainResults);
            },
            (e) => {
              reject(e);
            },
          );
      } else {
        resolve([
          {
            suggestions: [
              {
                isEmpty: true,
                name:
                  escapedValue.length === 0
                    ? 'type something to search'
                    : 'continue typing to search...',
              },
            ],
          },
        ]);
      }
    });
    p.then(
      (suggestions) => {
        this.setState({ loading: false, suggestions });
      },
      () => {
        this.setState({ loading: true, suggestions: [] });
      },
    );
    return p;
  }

  onSuggestionsClearRequested () {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected (event, { suggestion }) {
    if (!suggestion.isEmpty) {
      this.setState(
        {
          selectedValue: suggestion,
          value: this.getSuggestionValue(suggestion),
        },
        () => {
          this.props.onSelect(suggestion.user_id, suggestion);
        },
      );
    }
    if (this.fieldEl && this.fieldEl.input) {
      this.fieldEl.input.blur();
    }
  }

  getSuggestionValue (suggestion) {
    if (suggestion.isEmpty) {
      return '';
    }
    return `${suggestion.first_name} ${suggestion.last_name}`;
  }

  getSectionSuggestions (section) {
    return section.suggestions;
  }

  clearSelected () {
    this.setState(
      {
        selectedValue: null,
        value: '',
      },
      () => {
        this.forceFocus();
        this.props.onSelect(null, null);
      },
    );
  }

  forceFocus () {
    if (this.fieldEl && this.fieldEl.input) {
      this.fieldEl.input.focus();
    }
  }

  renderSuggestion (suggestion, { query }) {
    const name = suggestion.name || this.getSuggestionValue(suggestion);
    if (suggestion.isEmpty) {
      return (
        <a
          href=''
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{ cursor: 'not-allowed' }}>
          <em className='text-muted'>{name}</em>
        </a>
      );
    }
    const matches = match(name, query);
    const parts = parse(name, matches).map((part, id) => ({ ...part, id }));
    const isUser = suggestion._id !== null && suggestion._id !== undefined;
    return (
      <a
        href=''
        onClick={(e) => {
          e.preventDefault();
        }}>
        {isUser && <Avatar small user={suggestion} />}
        <span className={suggestion.is_id ? styles.idTag : ''}>
          {parts.map((part) => {
            const className = part.highlight ? styles.tagHighlight : null;
            return (
              <span className={className} key={part.id}>
                {part.text}
              </span>
            );
          })}
        </span>
      </a>
    );
  }

  renderSectionTitle (section) {
    return section.title ? `${section.title}:` : null;
  }

  render () {
    const { value, suggestions, loading, selectedValue } = this.state;
    const { disabled, label } = this.props;
    const hasSelected = selectedValue !== null;

    const inputProps = {
      placeholder: 'search by name or ID...',
      value,
      className: 'form-control',
      onChange: this.onChange,
      disabled: disabled || hasSelected,
    };
    const theme = {
      container: styles.autocomplete,
      suggestionsContainer: `dropdown open ${styles.suggestionsContainer}`,
      sectionContainer: `dropdown-menu ${styles.sectionContainer}`,
      suggestionsList: `dropdown-menu ${styles.suggestionsList}`,
      sectionTitle: 'dropdown-header',
      suggestion: '',
      suggestionFocused: 'active',
    };
    let icon = 'search';
    if (loading) {
      icon = 'spinner';
    } else if (hasSelected) {
      icon = 'times-circle';
    }

    return (
      <div>
        <FormGroup>
          {<ControlLabel>{(label || 'Owner')}:</ControlLabel>}
          <div className={styles.autocompleteWrapper}>
            <InputGroup>
              <Autosuggest
                theme={theme}
                multiSection
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                renderSectionTitle={this.renderSectionTitle}
                getSectionSuggestions={this.getSectionSuggestions}
                inputProps={inputProps}
                shouldRenderSuggestions={() => true}
                onSuggestionSelected={this.onSuggestionSelected}
                ref={(input) => {
                  this.fieldEl = input;
                }}
              />
              <InputGroup.Addon>
                <Button
                  bsStyle='link'
                  disabled={loading || disabled}
                  onClick={hasSelected ? this.clearSelected : this.forceFocus}>
                  <Fa
                    className={hasSelected ? '' : 'text-muted'}
                    name={icon}
                    spin={loading}
                  />
                </Button>
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </FormGroup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps (state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

UserSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isManager: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  label: PropTypes.string,
  userId: PropTypes.string,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  query: PropTypes.shape({}),
};
UserSelector.defaultProps = {
  disabled: false,
  isManager: false,
  onSelect: () => {},
  query: {},
  label: null,
  userId: null,
};

export default connect(mapStateToProps)(UserSelector);
